import { Component, input, ChangeDetectionStrategy } from '@angular/core';

import { IsDefinedNotEmptyPipe, IsDefinedPipe } from '@softline/ui-core';
import { KommissionsauftragBewe } from '../../types/kommissionsauftrag';
import { isDefinedNotEmpty } from '@softline/core';
import { BatchInfoComponent } from '@softapps/lager/core';

@Component({
  selector: 'soft-store-item',
  imports: [IsDefinedPipe, IsDefinedNotEmptyPipe, BatchInfoComponent],
  templateUrl: './store-item.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './store-item.component.css',
})
export class StoreItemComponent {
  readonly beweInput = input.required<KommissionsauftragBewe>({ alias: 'bewe' });
  readonly displayQuantity = input(true);
  readonly useScannedQuantity = input(false);
  protected readonly isDefinedNotEmpty = isDefinedNotEmpty;
}
